import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_result_cwtHotel",
  "use": "icon-ic_result_cwtHotel-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_result_cwtHotel\"><path d=\"M798.38 538.03l-575.1-346.2 0.04-68.75 575.04 345.6 0.02 69.35z\" fill=\"#FF694B\" p-id=\"11825\" /><path d=\"M798.38 538.03L223.3 894.99v-69.52l575.06-356.79 0.02 69.35z\" fill=\"#FF694B\" p-id=\"11826\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol